export const handleScroll = (e, fn) => {
  const bottom =
    e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
  if (bottom) {
    console.log("down");
    fn();
  }
};
